import { Box, Button, TextField } from "@modernatx-internal/component-library";
import React from "react";

import { useFinder } from "@/finder/hooks/V2/useFinder";
import type { LocationDropdownOption } from "@/finder/hooks/V2/useLocationSearch";

interface LocationSearchBarProps {
  handleOnBlur: () => void;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearchSubmit: () => void;
  handleSearchSuggestionClick: (option: LocationDropdownOption) => void;
  searchInputLabel: string;
  searchSuggestionsList: {
    label: string;
    value: string;
  }[];
  searchError: string;
}

const SearchButton: React.FC<{ onClick: (e: React.MouseEvent<HTMLButtonElement>) => void }> = ({
  onClick
}) => <Button icon="arrow-right" aria-label="Search" disabled={false} onClick={onClick} />;

export const LocationSearchBar: React.FC<LocationSearchBarProps> = ({
  handleOnBlur,
  handleSearchChange,
  handleSearchSubmit,
  handleSearchSuggestionClick,
  searchInputLabel,
  searchSuggestionsList,
  searchError
}) => {
  const { searchValue } = useFinder();

  const button = React.useMemo(
    () => (
      <SearchButton
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault(); // Prevents form submission and page reload
          handleSearchSubmit();
        }}
      />
    ),
    [handleSearchSubmit]
  );

  return (
    <Box sx={{ position: "relative" }} data-track="finder-location-search-bar">
      <TextField
        error={searchError}
        dropdownOptions={searchSuggestionsList}
        searchIcon={() => button}
        label={searchInputLabel}
        required={true}
        type="select"
        value={searchValue}
        onChange={handleSearchChange}
        onEnter={handleSearchSubmit}
        onSelectOption={handleSearchSuggestionClick}
        onBlur={handleOnBlur}
      />
    </Box>
  );
};
